import AmexGDAB2BMoreDetails from './AmexGDAB2BMoreDetails';

export default AmexGDAB2BMoreDetails;
